import { render } from "./BNavMenu.vue?vue&type=template&id=d80193a0"
import script from "./BNavMenu.vue?vue&type=script&lang=js"
export * from "./BNavMenu.vue?vue&type=script&lang=js"

import "./BNavMenu.vue?vue&type=style&index=0&id=d80193a0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__